import { createSelector } from 'reselect'
import { Map } from 'immutable'

export const getGallery = (state: Map<any, any>) => state.get('gallery')

const getGalleryLazyLoaded = createSelector(getGallery, gallery => gallery.get('lazyLoaded'))

export const getGalleryPending = createSelector(getGallery, gallery => gallery.get('pending'))

export const getGallerySearchBy = createSelector(getGallery, gallery => gallery.get('search'))

export const getGalleryImages = createSelector(getGallery, gallery => gallery.get('images'))

export const getGalleryActivitiesImages = createSelector(getGalleryImages, images =>
  images.filter((image: Map<string, any>) => image.get('url').indexOf('activities') !== -1)
)

export const getGalleryOrganizationsImages = createSelector(
  getGalleryImages,
  getGalleryLazyLoaded,
  (images, lazyLoaded) =>
    images.filter((image: Map<string, any>) => image.get('url').indexOf('organizations') !== -1).slice(0, lazyLoaded)
)

export const getGalleryProtracksImages = createSelector(getGalleryImages, getGalleryLazyLoaded, (images, lazyLoaded) =>
  images.filter((image: Map<string, any>) => image.get('url').indexOf('protracks') !== -1).slice(0, lazyLoaded)
)

export const getGalleryEmailsImages = createSelector(getGalleryImages, getGalleryLazyLoaded, (images, lazyLoaded) =>
  images.filter((image: Map<string, any>) => image.get('url').indexOf('emails') !== -1).slice(0, lazyLoaded)
)

export const getGalleryPublicImages = createSelector(getGalleryImages, getGalleryLazyLoaded, (images, lazyLoaded) =>
  images.filter((image: Map<string, any>) => image.get('url').indexOf('public') !== -1).slice(0, lazyLoaded)
)

export const getGallerySprintsImages = createSelector(getGalleryImages, getGalleryLazyLoaded, (images, lazyLoaded) =>
  images.filter((image: Map<string, any>) => image.get('url').indexOf('sprints') !== -1).slice(0, lazyLoaded)
)

export const getSearchAtActivitiesImages = createSelector(
  getGalleryActivitiesImages,
  getGallerySearchBy,
  getGalleryLazyLoaded,
  (images, filterBy, lazyLoaded) => {
    return filterBy && filterBy.length >= 1
      ? images
          .filter((image: Map<string, any>) => {
            const usagePlaces = image.get('usagePlaces')
            const fileName = image.get('fileName')
            const placesToSearch = `${fileName}__${usagePlaces}`.toLowerCase()
            const filtersByLower = filterBy.toLowerCase().split(' ')
            return filtersByLower.every((by: string) => {
              return placesToSearch.includes(by)
            })
          })
          .slice(0, lazyLoaded)
      : images.slice(0, lazyLoaded)
  }
)

export const getGalleryLoaded = createSelector(getGallery, gallery => gallery.get('loaded'))

export const getImageForReplace = createSelector(getGallery, gallery => gallery.get('imageForReplace'))

export const getIsButtonDisable = createSelector(getGallery, gallery => gallery.get('isButtonDisable'))

export const getImageToDelete = createSelector(getGallery, gallery => gallery.get('imageToDelete'))

export const getImageUsagePlaces = createSelector([getGalleryActivitiesImages, getImageToDelete], (gallery, image) =>
  gallery.find((item: Map<string, any>) => item.get('url') === image).get('usagePlaces')
)
